// Typed re-export of the root app.config.ts so SPA code uses one import path.
import { config } from '@config/app.config';
import type { AppConfig, Locale } from '@config/app.config';

export { config };
export type { AppConfig, Locale };

/** Human-readable label for a source tier, from app.config.ts.
 *  Falls back to a generic "Tier N" if the tier isn't declared. */
export function tierLabel(tier: number): string {
  return config.sourceTiers.find((t) => t.tier === tier)?.label ?? `Tier ${tier}`;
}
